import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { CaptionService } from "../../../../utils/shared-services/caption.service";
import { WidgetConstants } from "../../constants/widget.constants";

@Component({
    selector: 'widgetDescriptionDialog',
    templateUrl: 'src/app/features/head-office-portal/templates/dialogs/widget-description-dialog.html',
    standalone: false
})
export class HoWidgetDescriptionDialog {
    public captions: any;
    public descriptionHTML: string;
    public helpURL: string;

    constructor(
        @Inject(MatDialogRef) public dialogRef: MatDialogRef<HoWidgetDescriptionDialog>,
        @Inject(MAT_DIALOG_DATA) private data: any,
        @Inject(CaptionService) private captionService,
    ) {
        this.captions = this.captionService.captions;
        this.helpURL = WidgetConstants.WIDGET_DESCRIPTION_URL + this.data.widgetID + ".html";
        if(this.data.descriptionHTML) {
            this.descriptionHTML = this.data.descriptionHTML;
            return;
        }
    }
}
